import { mapActions, mapState } from 'vuex'
import { Usuarios } from '@/stores/usuarios'
import { GetLocalDelegacao, SetLocalDelegacao } from '@/localStorage'
import './scss/style.scss'

export default {
   name: 'GrupoUsuario',

   async created() {
      await this.usuarios.ActionObterUserInfoNc()

      this.gruposUsuario = this.usuarios.userInfo.grupos

      if (GetLocalDelegacao()) {
         this.grupoSelecionado = GetLocalDelegacao()
         return
      }

      this.grupoSelecionado = this.gruposUsuario[0].gestorId

      SetLocalDelegacao(this.grupoSelecionado)
   },

   data() {
      return {
         usuarios: Usuarios(),
         userService: null,

         form: {},
         grupoSelecionado: null,
         gruposUsuario: null
      }
   },

   methods: {
      async recarregar() {
         SetLocalDelegacao(this.grupoSelecionado)

         await this.usuarios.ActionCarregarInfo()

         this.$router.push('/home')
      }
   }
}
